import React from "react";
import { Button } from "@aidkitorg/component-library";
import { ApplicantCountFormFields } from "./ApplicantCountFormFields";
import { CreateComponentProps } from "./CreateDashboardComponentTab";
import { useDashboards } from "../../../Contexts/DashboardsContext";
import { createStagedComponent } from "@aidkitorg/types/lib/admin-panel/dashboard";
import { useApplicantCountFormState } from "../hooks/useApplicantCountFormState";
import { useLocalizedStrings } from "../../../Localization";

export const ApplicantCountComponentConfig: React.FC<CreateComponentProps> = ({ setDisplayMode, onClose }) => {
  const L = useLocalizedStrings()
  const {
    title,
    setTitle,
    filterConfig,
    setFilterConfig,
    buildApplicantCountObject,
    isFormStateValid
  } = useApplicantCountFormState()

  const { setStagedComponents, getDashboardComponentTranslation } = useDashboards();

  const saveApplicantCountComponent = async () => {
    const newApplicantCount = buildApplicantCountObject();

    const translations = await getDashboardComponentTranslation(newApplicantCount);
    if (translations && translations.success) {
      const stagedComponent = createStagedComponent(newApplicantCount, translations.data);
      setStagedComponents(prev => [...prev, stagedComponent]);
      setDisplayMode('create');
      onClose?.();
    } else {
      console.error("Failed to translate applicant count component:", newApplicantCount);
      // TODO: Add user-facing error message
    }
  };

  return (
    <div className="flex flex-col gap-y-2">
      <ApplicantCountFormFields
        title={title}
        setTitle={setTitle}
        filterConfig={filterConfig}
        setFilterConfig={setFilterConfig}
      />

      <div className="flex justify-between gap-x-2 pt-2">
        <Button
          onClick={() => setDisplayMode('create')}
          className="!w-1/2"
          variant="secondary"
        >
          {L.admin_panel.dashboards.cancel}
        </Button>
        <Button
          onClick={saveApplicantCountComponent}
          isDisabled={!isFormStateValid}
          className="!w-1/2"
        >
          {L.admin_panel.dashboards.save}
        </Button>
      </div>
    </div>
  );
};